const getPrincipleompoundInterest = (
  principle: number, // Total initial investment
  interestRate: number, // Percentage
  compoundFrequency: number, // number per year: eg monthly = 12/year = 12
  timeFrame: number, // In years
) => {
  const decimalInterest = interestRate / 100;

  return (
    principle *
    (1 + decimalInterest / compoundFrequency) ** (compoundFrequency * timeFrame)
  );
};

const getFutureValueOfASeries = (
  monthlyPayment: number, // Amount contributed per month
  interestRate: number, // Percentage
  compoundFrequency: number, // number per year: eg monthly = 12/year = 12
  timeFrame: number, // In years
  contributionsInBeginning: boolean = true, // If contributions are made at the first of the period or not
) => {
  const decimalInterest = interestRate / 100;
  const futureValue =
    monthlyPayment *
    (((1 + decimalInterest / compoundFrequency) **
      (compoundFrequency * timeFrame) -
      1) /
      (decimalInterest / compoundFrequency));

  if (contributionsInBeginning) {
    return futureValue * (1 + decimalInterest / compoundFrequency);
  }

  return futureValue;
};

const getMonthlyPaymentForFutureValue = (
  futureValue: number, // Amount to end
  interestRate: number, // Percentage
  compoundFrequency: number, // number per year: eg monthly = 12/year = 12
  timeFrame: number, // In years
) => {
  const decimalInterest = interestRate / 100;
  const monthlyPayment =
    futureValue /
    (((1 + decimalInterest / compoundFrequency) **
      (compoundFrequency * timeFrame) -
      1) /
      (decimalInterest / compoundFrequency));

  return monthlyPayment;
};

const getAmortizationPayments = (
  principle: number,
  interestRate: number, // Percentage
  months: number,
) => {
  const ratePerMonth = interestRate / 12;
  const decimalRate = ratePerMonth / 100;

  const monthlyPayment =
    (principle * (decimalRate * (1 + decimalRate) ** months)) /
    ((1 + decimalRate) ** months - 1);

  return monthlyPayment;
};

export {
  getAmortizationPayments,
  getFutureValueOfASeries,
  getMonthlyPaymentForFutureValue,
  getPrincipleompoundInterest,
};
